// src/components/atomic-crm/tasks/MyTasksInput.tsx
import { useState } from "react";
import { useListFilterContext, useTranslate } from "ra-core";
import { Label } from "@/components/ds/ui/label";
import { Switch } from "@/components/ds/ui/switch";
import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";
import { useCurrentSalesId } from "@/hooks/useCurrentSales";

export const MyTasksInput = ({
  source = "assigned_to",
  label,
}: {
  alwaysOn?: boolean;
  source?: string;
  label?: string;
}) => {
  const { filterValues, displayedFilters, setFilters } = useListFilterContext();
  const translate = useTranslate();
  const resolvedLabel = label ?? translate("crm.filter.my_tasks");
  const mySalesId = useCurrentSalesId();
  const [isLoading, setIsLoading] = useState(false);

  // We store the "on" state as presence of the `id@in` filter
  const isOn = typeof filterValues["id@in"] !== "undefined";

  const handleChange = async () => {
    const newFilterValues = { ...filterValues };

    if (isOn) {
      // Toggle off
      delete newFilterValues["id@in"];
      setFilters(newFilterValues, displayedFilters);
      return;
    }

    if (mySalesId == null) return;

    setIsLoading(true);
    try {
      const { data: rows } = await supabase
        .from("crm_activity_assignees")
        .select("activity_id")
        .eq("sales_id", mySalesId);

      const ids = (rows ?? []).map((r: any) => r.activity_id);

      // If nothing assigned, filter to a sentinel that matches nothing
      newFilterValues["id@in"] = ids.length ? `(${ids.join(",")})` : "(0)";
      setFilters(newFilterValues, displayedFilters);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-auto pb-2.25">
      <div className="flex items-center space-x-2">
        <Switch
          id="my-tasks"
          checked={isOn}
          onCheckedChange={handleChange}
          disabled={isLoading || mySalesId == null}
        />
        <Label htmlFor="my-tasks">{resolvedLabel}</Label>
      </div>
    </div>
  );
};
